import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-integration-edit',
  templateUrl: './integration-edit.component.html',
  styleUrls: ['./integration-edit.component.scss']
})
export class IntegrationEditComponent implements OnInit {

  constructor(private dynamicDialogRef: DynamicDialogRef) { }

  ngOnInit() {
  }

  save(){
    this.dynamicDialogRef.close();
  }
  
  cancel() {
    this.dynamicDialogRef.close();
  }
}
